import { ColorBy, ColorByType } from "../../map/models/ColorBy";

export namespace DashboardTypes {
  export enum ItemType {
    MiniMap = "MiniMap",
    PieChartColorBy = "PieChartColorBy",
    PieChartFullScore = "PieChartFullScore",
    TableTreatmentSuggestionCounter = "TableTreatmentSuggestionCounter",
    TableDistancePerAttributeValue = "TableDistancePerAttributeValue"

  }

  export interface Item {
    type: ItemType;
    name: string | null;
    colSpan: number | null;
  }

  export interface PieChartColorBy extends Item {
    type: ItemType.PieChartColorBy;
    colorBy: ColorBy;
  }

  export interface CreateDashboardRequest {
    projectId: string;
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface UpdateDashboardRequest {
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface Dashboard {
    id: string;
    projectId: string;
    name: string;
    items: DashboardTypes.Item[];
    createdAt: string;
    createdById: string;
  }

  export const getDefaultItemByType = (type: ItemType) => {
    const baseItem: DashboardTypes.Item = {
      type,
      name: null,
      colSpan: null,
    };
    switch (type) {
      case ItemType.PieChartColorBy:
        return {
          ...baseItem,
          colorBy: {
            type: ColorByType.Score,
            scoreKey: "global",
          },
        } as DashboardTypes.PieChartColorBy;
      default:
        return baseItem;
    }
  };
}
